import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IUserModel } from 'models/user.model'
import EditSupervisorsModal from './components/EditSupervisorsModal'
import styles from './UserInfo.module.scss'


interface EditSupervisorsProps {
  userId: number
  supervisors: IUserModel[]
}

export function EditSupervisors({ userId, supervisors }: EditSupervisorsProps) {
  const { t } = useTranslation()
  const [showEditModal, setShowEditModal] = useState(false)

  return (
    <>
      <button
        className={styles.negativePrimary}
        onClick={() => {
          setShowEditModal(true)
        }}
      >
        {t('configuration.user.editSupervisors')}
      </button>
      <EditSupervisorsModal
        show={showEditModal}
        initialState={supervisors}
        userId={userId}
        onClose={() => {
          setShowEditModal(false)
        }}
      />
    </>
  )
}
